<template>
  <SectionCajamarcaHero/>
  <SectionCajamarcaContent_Section/>
  <SectionCajamarcaContent_Section_2/>
  <SectionCajamarcaContent_Section_3/>
  <SectionCajamarcaContent_Section_4/>
  <SectionCajamarcaContent_Section_5 @add-to-cart="addToCart"/>
  <SectionCajamarcaContent_Section_6/>
  <SectionRainbowFooter/>
</template>


<script setup>
useSeoMeta({
  layout:() => "default",
  title:() => "Cajamarca: Rony Lavan\'s Exceptional Peruvian Microlot Coffee",
  description: () => "Discover the treasure of Cajamarca with Rony Lavan\'s traceable Peruvian microlot coffee. Savor the rich flavors and support sustainable farming practices",
})


const products = [
{id:'40627885506620', qty: 1, price: 51.00 , title: 'Organic Cajamarca Microlot x1',discount:''},
{id:'40627885539388', qty: 1, price: 137.85 , title: 'Organic Cajamarca Microlot x3',discount:'?discount=JWN716KJS7HS'},
{id:'40627885572156', qty: 1, price: 239.70 , title: 'Organic Cajamarca Microlot x6',discount:'?discount=B9PHGEZSQ5YQ'},
];
provide('products', products);

// onMounted(() =>{
//   const trackView = inject("trackView", () => {});
//   trackView("Home", "/cajamarca")
// })

</script>